    <!-- Mobile backdrop -->
    <div class="sidebar-backdrop" *ngIf="sidebarOpen" (click)="sidebarOpen=false"></div>

    <div class="shell">
      <!-- ── Sidebar ── -->
      <aside class="sidebar" [class.sidebar-open]="sidebarOpen">
        <div class="sidebar-brand">
          <div class="brand-logo">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="9 22 9 12 15 12 15 22" stroke="#fff" stroke-width="2"/></svg>
          </div>
          <div class="brand-text">
            <span class="brand-name">SiteWare</span>
            <span class="brand-tagline">STR Operations</span>
          </div>
          <button class="collapse-btn" (click)="sidebarOpen=false" title="Close sidebar">‹</button>
        </div>

        <nav class="sidebar-nav">
          <p class="nav-section-label">Main Menu</p>
          <a *ngFor="let item of visibleMain"
             [routerLink]="item.route"
             routerLinkActive="nav-active"
             class="nav-item"
             (click)="onNavItemClick(item)">
            <span class="nav-icon">{{item.icon}}</span>
            <span class="nav-label">{{item.label}}</span>
          </a>

          <ng-container *ngIf="visibleOps.length > 0">
            <p class="nav-section-label mt">Operations</p>
            <a *ngFor="let item of visibleOps"
               [routerLink]="item.route"
               routerLinkActive="nav-active"
               class="nav-item"
               (click)="onNavItemClick(item)">
              <span class="nav-icon">{{item.icon}}</span>
              <span class="nav-label">{{item.label}}</span>
            </a>
          </ng-container>

          <ng-container *ngIf="visibleMgmt.length > 0">
            <p class="nav-section-label mt">Management</p>
            <a *ngFor="let item of visibleMgmt"
               [routerLink]="item.route"
               routerLinkActive="nav-active"
               class="nav-item"
               (click)="onNavItemClick(item)">
              <span class="nav-icon">{{item.icon}}</span>
              <span class="nav-label">{{item.label}}</span>
            </a>
          </ng-container>

          <ng-container *ngIf="visibleAdmin.length > 0">
            <p class="nav-section-label mt">Platform Admin</p>
            <a *ngFor="let item of visibleAdmin"
               [routerLink]="item.route"
               routerLinkActive="nav-active"
               class="nav-item nav-item-admin"
               (click)="onNavItemClick(item)">
              <span class="nav-icon">{{item.icon}}</span>
              <span class="nav-label">{{item.label}}</span>
            </a>
          </ng-container>
        </nav>

        <div class="sidebar-footer">
          <a routerLink="/help" routerLinkActive="footer-link-active" class="footer-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/><path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
            Help &amp; Support
          </a>
        </div>
      </aside>

      <!-- ── Main Area ── -->
      <div class="main-area">
        <header class="topbar">
          <div class="topbar-left">
            <!-- Hamburger / sidebar toggle -->
            <button class="hamburger-btn" (click)="sidebarOpen=!sidebarOpen" title="Toggle menu">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2.2" stroke-linecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
            </button>
            <div class="search-wrapper" (click)="$event.stopPropagation()">
              <div class="search-bar" [class.search-bar-active]="showResults">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><circle cx="11" cy="11" r="8" stroke="#94a3b8" stroke-width="2"/><line x1="21" y1="21" x2="16.65" y2="16.65" stroke="#94a3b8" stroke-width="2"/></svg>
                <input [(ngModel)]="searchQuery" (input)="onSearchInput()" (focus)="onSearchFocus()" (keydown.escape)="closeSearch()" placeholder="Search anything..." autocomplete="off" />
                <button *ngIf="searchQuery" class="search-clear" (click)="clearSearch()">&#x2715;</button>
              </div>
              <div class="search-dropdown" *ngIf="showResults">
                <div class="search-loading" *ngIf="searching">
                  <span class="search-spinner"></span> Searching...
                </div>
                <ng-container *ngIf="!searching && searchResults">
                  <ng-container *ngIf="hasResults(); else noResults">
                    <ng-container *ngIf="searchResults.tasks?.length">
                      <div class="result-group-label">Tasks</div>
                      <div class="result-item" *ngFor="let hit of searchResults.tasks" (click)="navigateTo(hit)">
                        <span class="result-item-icon">✅</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="searchResults.workOrders?.length">
                      <div class="result-group-label">Work Orders</div>
                      <div class="result-item" *ngFor="let hit of searchResults.workOrders" (click)="navigateTo(hit)">
                        <span class="result-item-icon">🔧</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="searchResults.inspections?.length">
                      <div class="result-group-label">Inspections</div>
                      <div class="result-item" *ngFor="let hit of searchResults.inspections" (click)="navigateTo(hit)">
                        <span class="result-item-icon">🔍</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="searchResults.reservations?.length">
                      <div class="result-group-label">Reservations</div>
                      <div class="result-item" *ngFor="let hit of searchResults.reservations" (click)="navigateTo(hit)">
                        <span class="result-item-icon">🛎️</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="searchResults.properties?.length">
                      <div class="result-group-label">Properties</div>
                      <div class="result-item" *ngFor="let hit of searchResults.properties" (click)="navigateTo(hit)">
                        <span class="result-item-icon">🏢</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="searchResults.staff?.length">
                      <div class="result-group-label">Staff</div>
                      <div class="result-item" *ngFor="let hit of searchResults.staff" (click)="navigateTo(hit)">
                        <span class="result-item-icon">👤</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="searchResults.workLists?.length">
                      <div class="result-group-label">List Groups</div>
                      <div class="result-item" *ngFor="let hit of searchResults.workLists" (click)="navigateTo(hit)">
                        <span class="result-item-icon">📋</span>
                        <div class="result-item-body">
                          <div class="result-item-label">{{hit.label}}</div>
                          <div class="result-item-sub" *ngIf="hit.subLabel">{{hit.subLabel}}</div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #noResults>
                    <div class="search-no-results">No results for "{{searchQuery}}"</div>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="topbar-right">
            <button class="topbar-icon-btn" title="Notifications" (click)="toggleNotifications($event)">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></svg>
              <span class="icon-badge" *ngIf="unreadNotifications > 0"></span>
            </button>
            <!-- Notification Dropdown -->
            <div class="notification-panel" *ngIf="notifOpen" (click)="$event.stopPropagation()">
              <div class="notif-header">
                <span>Notifications</span>
                <button class="notif-clear" (click)="clearNotifications()">Clear all</button>
              </div>
              <div class="notif-list">
                <div class="notif-item" *ngFor="let n of notifications" [class.unread]="!n.read" (click)="markRead(n)">
                  <span class="notif-icon">{{n.icon}}</span>
                  <div class="notif-body">
                    <div class="notif-text">{{n.text}}</div>
                    <div class="notif-time">{{n.time}}</div>
                  </div>
                </div>
                <div *ngIf="notifications.length === 0" class="notif-empty">No notifications</div>
              </div>
            </div>
            <button class="topbar-icon-btn" title="Messages" (click)="router.navigate(['/messages'])">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
            </button>
            <button class="topbar-icon-btn" title="Calendar">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </button>
            <button class="topbar-icon-btn" [title]="isFullscreen ? 'Exit full screen' : 'Full screen'" (click)="toggleFullscreen($event)">
              <svg *ngIf="!isFullscreen" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 00-2 2v3M16 3h3a2 2 0 012 2v3M8 21H5a2 2 0 01-2-2v-3M16 21h3a2 2 0 002-2v-3"/></svg>
              <svg *ngIf="isFullscreen" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3v3a2 2 0 01-2 2H4M15 3v3a2 2 0 002 2h3M9 21v-3a2 2 0 00-2-2H4M15 21v-3a2 2 0 012-2h3"/></svg>
            </button>
            <div class="topbar-divider"></div>
            <div class="topbar-user" (click)="router.navigate(['/profile'])" style="cursor:pointer" title="View Profile">
              <div class="topbar-av">{{initials}}</div>
              <div class="topbar-user-info">
                <span class="topbar-username">{{currentUser?.fullName}}</span>
                <span class="topbar-role">{{currentUser?.role}}</span>
              </div>
              <button class="sign-out-btn" (click)="$event.stopPropagation(); logout()" title="Sign out">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
              </button>
            </div>
          </div>
        </header>
        <main class="main-content" [class.messaging-mode]="router.url.startsWith('/messages')">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
    <app-toast></app-toast>
    <app-confirm-dialog></app-confirm-dialog>
  